import BaseService from '../common/BaseService';
import {
    ADDRESS_VALIDATION,
    AFFORDABILITY,
    BLOOD_RELATIONSHIPS,
    BLOOD_RELATIONSHIPS_ALL,
    CHECK_BLOOD_RELATIONSHIPS,
    COUNTIES_FOR_ZIPCODE,
    COUNTRIES,
    ENROLLMENTS,
    IMMIGRATION_INFO,
    SSAP_DATA,
    SSAP_DATA_BY_CASENUMBER,
    SSAP_DATA_PREVIOUS,
    SSAP_DATA_SAVE,
    SSAP_FLOW,
    SSAP_SETTINGS,
    SSNS,
    SUMMARY_TO_INBOX,
    TRIBES
} from '../common/endpoints';
import { localStorageHyperDashboardTools } from '@utils/tools/localStorageHyperDashboardTools';

export default class SsapService extends BaseService {
    constructor(props) {
        super(props);
        this.client.interceptors.response.use(this.processResponse, this.processError);
    }

    checkBloodRelationships(data) {
        return this.client.post(CHECK_BLOOD_RELATIONSHIPS, data).then(response => response.data);
    }

    getAffordability(replacements) {
        return this.client.get(AFFORDABILITY, { replacements }).then(response => response.data);
    }

    getBloodAllRelationships() {
        return this.client.get(BLOOD_RELATIONSHIPS_ALL).then(response => response.data);
    }

    getBloodRelationships() {
        return this.client.get(BLOOD_RELATIONSHIPS).then(response => response.data);
    }

    getCountiesForZipcode(replacements) {
        return this.client.get(COUNTIES_FOR_ZIPCODE, { replacements }).then(response => response.data);
    }

    getCountries() {
        return this.client.get(COUNTRIES).then(response => response.data);
    }

    getEnrollments(data) {
        return this.client.post(ENROLLMENTS, data).then(response => response.data);
    }

    getFlow() {
        return this.client.get(SSAP_FLOW).then(response => response.data);
    }

    getInitialData(replacements) {
        return this.client.get(SSAP_DATA, { replacements }).then(response => response.data);
    }

    getInitialDataByCaseNumber(replacements) {
        return this.client.get(SSAP_DATA_BY_CASENUMBER, { replacements }).then(response => response.data);
    }

    getPreviousData(replacements) {
        return this.client.get(SSAP_DATA_PREVIOUS, { replacements }).then(response => response.data);
    }

    getSettings(replacements) {
        return this.client.get(SSAP_SETTINGS, { replacements }).then(response => response.data);
    }

    getTribes() {
        return this.client.get(TRIBES).then(response => response.data);
    }

    receiveImmigrationInfo(data) {
        return this.client.post(IMMIGRATION_INFO, data).then(response => response.data);
    }

    receiveSSNs(data) {
        return this.client.post(SSNS, data).then(response => response.data);
    }

    sendToInbox(replacements) {
        return this.client.get(SUMMARY_TO_INBOX, { replacements }).then(response => response.data);
    }

    saveApplication(data) {
        const { hashMap, ...rest } = data;
        return this.client.post(SSAP_DATA_SAVE, rest, {
            headers: {
                'X-Data-Hash': hashMap,
            },
        }).then(response => response.data);
    }

    validateAddress(data) {
        return this.client.post(ADDRESS_VALIDATION, data).then(response => response.data);
    }

    processError = error => {
        return Promise.reject(error);
    };

    processResponse = (...args) => {
        let [ response ] = args;
        const {
            config: {
                data,
                url
            }
        } = response;

        // Here responses for Development environment (port 8888) might be intercepted and mocked
        // Use check: response.config.url === endpoint we hit)
        // Stringified request body is also accessible in response.config.data;

        if(global.__ENV__.DEVELOPMENT) {
            if(typeof data === 'string' && url.startsWith(SSAP_DATA_SAVE)) {

                const finalized = JSON.parse(JSON.parse(data).application).finalized;

                const application = JSON.parse(JSON.parse(data).application);
                const otherPropsInBody = JSON.parse(data);
                delete otherPropsInBody.application;

                const areConsolesShown = localStorageHyperDashboardTools.getValueByPropName(
                    'areSentToBackendConsolesShown',
                    false,
                );

                areConsolesShown && console.log({
                    otherPropsInBody,
                    maxAchievedPage: application.maxAchievedPage,
                    incomes: application.taxHousehold?.[0].householdMember[0].incomes
                });

                if(finalized) {
                    return {
                        ...response,
                        data: { 'success': true, 'encryptedCaseNumber': '15%7dfhjd@3' }
                    };
                } else {
                    return {
                        ...response,
                        data: JSON.parse(JSON.parse(data).application)
                    };
                }
            }
        }

        return response;
    };
}